import React from 'react';
import UnifiedDashboardLayout from '../components/UnifiedDashboardLayout';
import SubmissionsAdmin from '../components/admin/submissions/SubmissionsAdmin';
import { Crown, Users, Palette, TrendingUp, Award, Eye, Activity, MoreVertical } from 'lucide-react';

const AdminSubmissions = () => {
  // Define navigation items for admin
  const navItems = [
    { name: 'Overview', href: '/admin/dashboard', icon: Crown },
    { name: 'Users', href: '/admin/users', icon: Users },
    { name: 'Artists', href: '/admin/artists', icon: Palette },
    { name: 'Collections', href: '/admin/collections', icon: TrendingUp },
    { name: 'Artworks', href: '/admin/artworks', icon: Eye },
    { name: 'Events', href: '/admin/events', icon: Activity },
    { name: 'Submissions', href: '/admin/submissions', icon: Award },
    { name: 'Notifications', href: '/admin/notifications', icon: MoreVertical },
    { name: 'SmartPulse', href: '/admin/pulse', icon: TrendingUp },
  ];

  return (
    <UnifiedDashboardLayout
      dashboardType="admin"
      navItems={navItems}
      logoText="Admin Dashboard"
      logoIcon={Crown}
    >
      <SubmissionsAdmin />
    </UnifiedDashboardLayout>
  );
};

export default AdminSubmissions;
